import { CommonProductQueryParams } from '../commonProductQueryParams';
import { easyEstimatorApi } from '../easyEstimatorService';

import { ApiUrl } from '~/core/enums';
import { OptionalProduct } from '~/core/models';

const mileageTiersApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchMileageTiers: builder.query<
      OptionalProduct[],
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: ApiUrl.MILEAGE_TIERS_URL,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useFetchMileageTiersQuery } = mileageTiersApi;
